import _ from 'lodash';
import { createFsDocKey_alt } from '../../../global/firestoreData/appData/fsAppData';
import { matchCalcs } from './match';
import { _matchLsTypes, _matchStatusTypes } from 'projectSpecific/sports/helpers/sportsEnums';

/**
 * 
 * @param {*} matches_db matches from the database
 * @param {*} matches_gs matches from the google sheet
 * @param {*} teams all the teams
 * @param {*} forPlayoffs 
 * @returns 
 */
export const getMatchUpdates = (mainDb, matches_info, matches_gs, teams, forPlayoffs, forRefresh, gameScoringType) => {

  // from the APP
  const { matches, matches_playoffs } = matches_info ?? {}
  const matches_db = forPlayoffs ? matches_playoffs : matches

  const matchUpdates = compareMatches(mainDb, matches_gs, matches_db, teams, forPlayoffs, gameScoringType)

  matchCalcs.calcAllVballMatches(matchUpdates)

  const matchUpdates_dot = {}
  const matchUpdates_grouped = groupByMatchStatusTypes(matchUpdates)
  createMatchUpdates_data(matchUpdates, matchUpdates_dot, matchUpdates_grouped, forPlayoffs)

  const matchUpdates_dupped = _.filter(matchUpdates, { _isDuplicated: true })

  const matchResultsInfo = {
    matchUpdates_dot,
    matchUpdates_dot_mcks: forPlayoffs ? matchUpdates_dot?.['seasonPlayoff'] : matchUpdates_dot?.['season'],
    matchUpdates_grouped,
    matchUpdates_grouped_current: forPlayoffs ? matchUpdates_grouped?.['seasonPlayoff'] : matchUpdates_grouped?.['season'],
    matchUpdates,
    matchUpdates_dupped,
  }

  console.log('matchUpdates_dupped', matchUpdates_dupped)

  return matchResultsInfo

}

export const createMatchUpdates_data = (matches, matchUpdates_dot, matchUpdates_grouped, forPlayoffs) => {

  _.forEach(matches, (m) => {
    if (m.home && !m.home._itemKey && m.home.id) {
      m.home._itemKey = m.home.id
    }
    if (m.away && !m.away._itemKey && m.away.id) {
      m.away._itemKey = m.away.id
    }
  })

  // 2 groupds: seasonPlayoff and season
  const _matches_season = _.mapKeys(
    _.groupBy(matches, 'isPlayoff'),
    (_, key) => (key === 'true' ? _matchStatusTypes.seasonPlayoff : _matchStatusTypes.season)
  );

  _.forEach(_matches_season, (ms, matchType) => {
    const updates = {}
    const _matches = matchType === _matchStatusTypes.seasonPlayoff ? _.groupBy(ms, 'levels') : _.groupBy(ms, '_matchCollectionKey')
    _.forEach(_matches, (_levelMatches, levelKey) => {
      if (!updates[levelKey]) { updates[levelKey] = {} }
      _.forEach(_levelMatches, (levelMatch, matchKey) => {
        const { isPlayoff, _itemKey } = levelMatch
        const _matchPrefix = isPlayoff ? 'playoffMatches' : 'matches'
        if (!levelMatch.teams && levelMatch?.away?.id && levelMatch?.home?.id) {
          levelMatch.teams = [levelMatch.away.id, levelMatch.home.id]
        }
        updates[levelKey][_matchPrefix + '.' + _itemKey] = levelMatch
      })
    })
    matchUpdates_dot[matchType] = updates
    if (matchUpdates_grouped) {
      matchUpdates_grouped[matchType] = _.values(ms)
    }
  })
}

export const createMatchLevelUpdate_data = () => {
  _.forEach(_matches, (_levelMatches, levelKey) => {
    if (!updates[levelKey]) { updates[levelKey] = {} }
    _.forEach(_levelMatches, (levelMatch, matchKey) => {
      const { isPlayoff, _itemKey } = levelMatch
      const _matchPrefix = isPlayoff ? 'playoffMatches' : 'matches'
      if (!levelMatch.teams && levelMatch?.away?.id && levelMatch?.home?.id) {
        levelMatch.teams = [levelMatch.away.id, levelMatch.home.id]
      }
      updates[levelKey][_matchPrefix + '.' + _itemKey] = levelMatch
    })
  })
}

const convertGsMatchToExistingFormat = (gsMatch, teams) => {

  const homeTeam = _.find(teams, { name: gsMatch.home }) || {};
  const awayTeam = _.find(teams, { name: gsMatch.away }) || {};

  const bothHaveKeys = homeTeam._itemKey && awayTeam._itemKey;
  const sameLevel = homeTeam.levels === awayTeam.levels;
  const sameSection = homeTeam.sections === awayTeam.sections;

  let matchLevels = _matchLsTypes.Non;
  let _matchCollectionKey = _matchLsTypes.Non;

  if (sameLevel && sameSection) {
    matchLevels = homeTeam.levels;
    _matchCollectionKey = homeTeam.levels;
  } else if (!bothHaveKeys) {
    matchLevels = _matchLsTypes.nonDistrict;
    _matchCollectionKey = _matchLsTypes.nonDistrict;
  } else if (sameLevel) {
    matchLevels = homeTeam.levels;
  }

  const matchSections = ((awayTeam.sections === homeTeam.sections) && (awayTeam.levels === homeTeam.levels))
    ? homeTeam.sections
    : _matchLsTypes.Non;

  const match = {
    home: {
      id: homeTeam._itemKey || gsMatch.home,
      name: homeTeam.name || gsMatch.home,
      levels: homeTeam.levels || _matchLsTypes.Non,
      sections: homeTeam.sections || _matchLsTypes.Non,
    },
    away: {
      id: awayTeam._itemKey || gsMatch.away,
      name: awayTeam.name || gsMatch.away,
      levels: awayTeam.levels || _matchLsTypes.Non,
      sections: awayTeam.sections || _matchLsTypes.Non,
    },
    startDate: gsMatch.startDate,
    startTime: '7:00 PM',
    levels: matchLevels ? matchLevels : _matchLsTypes.Non,
    sections: matchSections ? matchSections : _matchLsTypes.Non,
    _matchCollectionKey: _matchCollectionKey,
  };

  const homeScoreExists = gsMatch.homeScore !== undefined && gsMatch.homeScore !== null && gsMatch.homeScore !== '';
  const awayScoreExists = gsMatch.awayScore !== undefined && gsMatch.awayScore !== null && gsMatch.awayScore !== '';

  if (homeScoreExists && awayScoreExists) {
    match.results = {
      score: {
        home: Number(gsMatch.homeScore),
        away: Number(gsMatch.awayScore),
      },
    };
  }

  return match;
};

const createScoresObject = (obj) => {
  const scores = {};

  for (let i = 1; i <= 5; i++) {
    const homeKey = `home${i}`;
    const awayKey = `away${i}`;

    if (obj[homeKey] !== undefined || obj[awayKey] !== undefined) {
      scores[i] = {
        home: Number(obj[homeKey]),
        away: Number(obj[awayKey]),
      };
    }
  }

  return scores;
};

const getMatchesToRemove = (matches, props) => {

  const grouped = {};

  _.forEach(matches, (m, idx) => {
    const key = JSON.stringify(_.pick(m, props));

    if (!grouped[key]) {
      grouped[key] = [];
    }

    grouped[key].push({ ...m, _idx: idx });
  });

  const matchingGroups = _.filter(_.values(grouped), (group) => group.length > 1);

  const matchesToRemove = _.flatMap(matchingGroups, (group) => {
    const matchWithResult = _.find(group, (match) => match.result);
    // Keep the match with the result, otherwise keep the first match
    const matchToKeep = matchWithResult || _.head(group);
    return _.filter(group, (match) => match._idx !== matchToKeep._idx);
  });

  return {
    matchesToRemove,
    matchingGroups
  };
};

/**
 * 
 * @param {object} matches_gs 
 * @param {object} matches_db 
 * @param {object} teams 
 * @param {string} gameScoringType 
 * @returns matchUpdates
 */
const compareMatches = (mainDb, matches_gs, matches_db, teams, forPlayoffs, gameScoringType) => {

  console.log('matches_gs', matches_gs)

  // const updates = [];
  const matchUpdates = {};

  const dupProps = ['home.name', 'away.name']
  const { matchesToRemove: match_dups, matchingGroups } = getMatchesToRemove(matches_db, dupProps)

  // LOOP allthe matches_gs
  _.forEach(matches_gs, match_gs => {

    // the playoff google sheet may have a pending (winner/loser) as a name. Ignore that match!
    if (!_.startsWith(match_gs.away, 'winner') && !_.startsWith(match_gs.away, 'loser')) {

      // tFIND the match_db by finding the matching away and home names
      let match_db = _.find(matches_db, em =>
        _.get(em, 'home.name') === match_gs.home &&
        _.get(em, 'away.name') === match_gs.away
      );

      let match_db_exact = _.find(matches_db, em =>
        _.get(em, 'home.name') === match_gs.home &&
        _.get(em, 'away.name') === match_gs.away &&
        _.get(em, 'startDate') === match_gs.startDate
      );

      let match_dbf = _.filter(matches_db, em =>
        _.get(em, 'home.name') === match_gs.home &&
        _.get(em, 'away.name') === match_gs.away
      );

      const match_db_alt = _.find(matches_db, em =>
        _.get(em, 'home.name') === match_gs.away &&
        _.get(em, 'away.name') === match_gs.home
      );

      const gsScoreHome = Number(match_gs.homeScore);
      const gsScoreAway = Number(match_gs.awayScore);

      const gsScoreHome3 = Number(match_gs.home3);
      const gsScoreAway3 = Number(match_gs.away3);

      const scores = createScoresObject(match_gs)

      // does it have a score
      const hasGsScore = match_gs.homeScore != null && match_gs.awayScore != null && !isNaN(gsScoreHome) && !isNaN(gsScoreAway);
      const hasGsScore3 = match_gs.home3 != null && match_gs.away3 != null && !isNaN(gsScoreHome3) && !isNaN(gsScoreAway3);

      // this is where the updateTypes from GS comes into play 

      let isCancelled = false;
      let isPostponed = false;
      let isExhibition = false;
      let isRemoved = false;

      if (match_gs?.updateTypes) {
        switch (match_gs.updateTypes) {
          case 'Cancelled':
            isCancelled = true;
            break;
          case 'Postponed':
            isPostponed = true;
            break;
          case 'Exhibition':
            isExhibition = true;
            break;
          case 'Remove':
            isRemoved = true;
            break;
        }
      }

      let isRemoved_app = isRemoved

      if (isRemoved_app) {
        if (!match_db_exact) {
          isRemoved_app = false
        }
      }

      if (forPlayoffs && !match_db && match_db_alt) {
        match_db = _.cloneDeep(match_db_alt)
        match_db.away = _.cloneDeep(match_db_alt.home);
        match_db.home = _.cloneDeep(match_db_alt.away);
      }

      if (match_db && match_dbf.length === 1) {

        // match has already been marked as cancelled
        if (isCancelled && match_db._isCancelled) { isCancelled = false }

        const { _itemKey, startDate } = match_db

        const emScoreHome = _.get(match_db, 'results.score.home');
        const emScores = _.get(match_db, 'results.scores');
        const emScoreAway = _.get(match_db, 'results.score.away');

        const scoresChanged = !_.isEmpty(scores) && !_.isEmpty(emScores) && !_.isEqual(scores, emScores);;
        const scoreDifferences = _.pickBy(scores, (score, key) => !_.isEqual(score, emScores?.[key]));

        if (!_.isEmpty(scoreDifferences)) {
          console.log('emScores', emScores)
          console.log('scores', scores)
          console.log('scoreDifferences', scoreDifferences)
        }

        const emMatchStatus = _.get(match_db, 'matchStatus');

        const scoreIsNew = hasGsScore && _.isNil(emScoreHome) && _.isNil(emScoreAway);
        const scoresIsNew = hasGsScore3 && _.isNil(emScores);
        const scoreChanged = !scoreIsNew && hasGsScore && ((emScoreHome !== gsScoreHome) || (emScoreAway !== gsScoreAway));

        const matchStatusChanged = match_gs.matchStatus !== emMatchStatus
        const dateChanged = match_gs.startDate !== startDate;

        if (matchStatusChanged || dateChanged || isCancelled || isRemoved_app || ((scoreChanged || scoreIsNew || scoresIsNew || scoresChanged))) {

          const mergedMatch = _.merge({}, match_db, {
            startDate: match_gs.startDate,
          });

          if (hasGsScore) {
            mergedMatch.results = {
              score: {
                home: gsScoreHome,
                away: gsScoreAway
              }
            }
          }



          if (!_.isEmpty(scores)) {
            mergedMatch.results.scores = scores
          }

          if (mergedMatch.startDate !== match_db.startDate) {
            mergedMatch._oldStartDate = match_db.startDate;
          }

          if (isCancelled) {
            mergedMatch._isCancelled = true
          }

          if (isRemoved_app) {
            mergedMatch._isRemoved = true
          }

          if (matchStatusChanged && match_gs.matchStatus) {
            mergedMatch.matchStatus = match_gs.matchStatus;
          }

          matchUpdates[_itemKey] = {
            ...mergedMatch,
            _matchChanges: {
              scoreChanged: scoreChanged,
              scoreIsNew: scoreIsNew,
              dateChanged: dateChanged,
              matchStatusChanged: matchStatusChanged,
              cancelled: isCancelled,
              removed: isRemoved_app,
            },
          }
        }
      } else if (!match_db) {

        // if the match is NEW, and it is marked as isCancelled or isRemoved, do NOT add it the list of new matches
        if (!isCancelled && !isRemoved) {

          const xxx = createFsDocKey_alt(mainDb)

          const transformedGsMatch = convertGsMatchToExistingFormat(match_gs, teams);
          transformedGsMatch._itemKey = xxx

          matchUpdates[xxx] = {
            ...transformedGsMatch,
            _matchChanges: {
              scoreChanged: false,
              scoreIsNew: false,
              dateChanged: false,
              matchStatusChanged: false,
              matchIsNew: true
            },
          }
        }
      }
    }
  });

  if (!forPlayoffs) {
    _.forEach(match_dups, (md => {
      matchUpdates[md?._itemKey] = {
        ...md,
        _isDuplicated: true,
        _matchChanges: {
          duplicated: true,
        },
      }
    }))
  }

  _.forEach(matchUpdates, (m) => {
    matchCalcs.calcVballMatch(m, gameScoringType)
  })

  return matchUpdates;
};

export const groupByMatchStatusTypes = (updatedMatches) => {
  return _.reduce(updatedMatches, (result, match) => {
    // Loop through each value in the _matchStatusTypes array
    _.forEach(match._matchStatusTypes, (status) => {
      if (status !== 'playoffs') {
        // Initialize the group if it doesn't exist
        if (!result[status]) {
          result[status] = [];
        }
        // Add the match to the appropriate group
        result[status].push(match);
      }
    });
    return result;
  }, {});
};

